<script>
import devData from './dev-data/weekly-milling-qty.json'
import api from '@/helpers/api'
import { sumBy, chain } from 'lodash'
import moment from 'moment'
import yearRangeMixin from './year-range.mixin'

export default {
  name: 'weekly-milling-qty.card',
  mixins: [yearRangeMixin],
  watch: {
    year: 'onRefresh'
  },
  data () {
    return {
      quantity: 0,
      trend: 0,
      prevTrend: 0,
      trendUp: true,
      series: []
    }
  },
  computed: {
    signedTrend () {
      return this.trendUp ? this.trend : -this.trend
    },
    chartOptions () {
      const color = this.sparklineColor(this.signedTrend)
      return {
        chart: {
          type: 'bar',
          sparkline: {
            enabled: true
          }
        },
        stroke: {
          curve: 'smooth',
          width: 2,
          colors: [color]
        },
        fill: {
          opacity: 0.85,
          type: 'solid'
        },
        dataLabels: {
          enabled: false
        },
        grid: {
          show: false
        },
        yaxis: {
          min: 0,
          show: false,
          labels: {
            show: false
          }
        },
        xaxis: {
          labels: {
            show: false
          },
          axisBorder: {
            show: false
          },
          axisTicks: {
            show: false
          }
        },
        colors: [color]
      }
    }
  },
  mounted () {
    this.onRefresh()
  },
  methods: {
    async onRefresh () {
      var result = []
      if (process.env.NODE_ENV !== 'production') {
        result = devData
      } else {
        result = await api.stats.weeklyQuantityByTag({
          start_date: this.yearStartFormatted,
          end_date: this.yearEndFormatted,
          tag: 'stat_qty_milling'
        })
      }

      var thisWeek = moment().startOf('isoWeek')
      var lastWeek = moment(thisWeek).subtract(1, 'weeks')

      var grouped = chain(result)
        .groupBy(x => moment(x.start_date).startOf('isoWeek'))
        .map((data, id) => ({
          start_date: id,
          value: sumBy(data, 'quantity')
        }))
        .value()

      this.quantity = sumBy(
        grouped.filter(x => moment(x.start_date).isSame(thisWeek)),
        'value'
      ).toFixed(0)

      this.prevTrend = sumBy(
        grouped.filter(x => moment(x.start_date).isSame(lastWeek)),
        'value'
      ).toFixed(0)

      var trend = ((this.quantity / this.prevTrend - 1) * 100).toFixed(0)

      if (this.prevTrend == 0) trend = 0

      this.trend = Math.abs(trend)
      this.trendUp = Number(trend) > 0

      var data = grouped
        .filter(x =>
          moment(x.start_date).isAfter(moment(thisWeek).subtract(2, 'months'))
        )
        .reverse()
        .map(x => Number(x.value.toFixed(0)))
      this.series = [
        {
          name: 'Millings',
          data
        }
      ]
    }
  }
}
</script>
<template>
  <div class="portal-card portal-card--metric">
    <div class="portal-card__metric-top">
      <div>
        <div class="portal-card__eyebrow">{{ $t('Weekly Millings') }}</div>
        <div class="portal-card__value">{{ quantity }}</div>
      </div>
      <div class="portal-card__sparkline">
        <apexchart
          :key="`wmq-${signedTrend}`"
          type="bar"
          height="45"
          width="100%"
          :options="chartOptions"
          :series="series"
        ></apexchart>
      </div>
    </div>
    <div class="portal-card__trend">
      <span
        class="portal-card__trend-value"
        :class="{
          'is-up': trendIsUp(signedTrend),
          'is-down': trendIsDown(signedTrend)
        }"
      >
        <i
          :class="
            trendIsDown(signedTrend)
              ? 'mdi mdi-trending-down'
              : 'mdi mdi-trending-up'
          "
        ></i>
        {{ formatTrendPercent(signedTrend) }}
      </span>
      <span class="portal-card__trend-label"
        >{{ $t('stats.sales.since_last_week') }} ({{ prevTrend }})</span
      >
    </div>
  </div>
</template>
